import type { I18NMessages } from '@atlaskit/intl-messages-provider/types';
import defaultMessages from '@atlassian/afm-i18n-platform-ai-mate-studio-browse-kit/i18n/en';

const asyncLanguages: Record<string, () => Promise<{ default: I18NMessages }>> = {
	cs: () =>
		import(
			/* webpackChunkName: "@atlaskit-internal_@atlassian/studio-browse-kit-i18n-cs" */
			'@atlassian/afm-i18n-platform-ai-mate-studio-browse-kit/i18n/cs'
		),
	da: () =>
		import(
			/* webpackChunkName: "@atlaskit-internal_@atlassian/studio-browse-kit-i18n-da" */
			'@atlassian/afm-i18n-platform-ai-mate-studio-browse-kit/i18n/da'
		),
	de: () =>
		import(
			/* webpackChunkName: "@atlaskit-internal_@atlassian/studio-browse-kit-i18n-de" */
			'@atlassian/afm-i18n-platform-ai-mate-studio-browse-kit/i18n/de'
		),
	'en-GB': () =>
		import(
			/* webpackChunkName: "@atlaskit-internal_@atlassian/studio-browse-kit-i18n-en_GB" */
			'@atlassian/afm-i18n-platform-ai-mate-studio-browse-kit/i18n/en_GB'
		),
	'en-ZZ': () =>
		import(
			/* webpackChunkName: "@atlaskit-internal_@atlassian/studio-browse-kit-i18n-en_ZZ" */
			'@atlassian/afm-i18n-platform-ai-mate-studio-browse-kit/i18n/en_ZZ'
		),
	es: () =>
		import(
			/* webpackChunkName: "@atlaskit-internal_@atlassian/studio-browse-kit-i18n-es" */
			'@atlassian/afm-i18n-platform-ai-mate-studio-browse-kit/i18n/es'
		),
	fi: () =>
		import(
			/* webpackChunkName: "@atlaskit-internal_@atlassian/studio-browse-kit-i18n-fi" */
			'@atlassian/afm-i18n-platform-ai-mate-studio-browse-kit/i18n/fi'
		),
	fr: () =>
		import(
			/* webpackChunkName: "@atlaskit-internal_@atlassian/studio-browse-kit-i18n-fr" */
			'@atlassian/afm-i18n-platform-ai-mate-studio-browse-kit/i18n/fr'
		),
	hr: () =>
		import(
			/* webpackChunkName: "@atlaskit-internal_@atlassian/studio-browse-kit-i18n-hr" */
			'@atlassian/afm-i18n-platform-ai-mate-studio-browse-kit/i18n/hr'
		),
	hu: () =>
		import(
			/* webpackChunkName: "@atlaskit-internal_@atlassian/studio-browse-kit-i18n-hu" */
			'@atlassian/afm-i18n-platform-ai-mate-studio-browse-kit/i18n/hu'
		),
	it: () =>
		import(
			/* webpackChunkName: "@atlaskit-internal_@atlassian/studio-browse-kit-i18n-it" */
			'@atlassian/afm-i18n-platform-ai-mate-studio-browse-kit/i18n/it'
		),
	ja: () =>
		import(
			/* webpackChunkName: "@atlaskit-internal_@atlassian/studio-browse-kit-i18n-ja" */
			'@atlassian/afm-i18n-platform-ai-mate-studio-browse-kit/i18n/ja'
		),
	ko: () =>
		import(
			/* webpackChunkName: "@atlaskit-internal_@atlassian/studio-browse-kit-i18n-ko" */
			'@atlassian/afm-i18n-platform-ai-mate-studio-browse-kit/i18n/ko'
		),
	nb: () =>
		import(
			/* webpackChunkName: "@atlaskit-internal_@atlassian/studio-browse-kit-i18n-nb" */
			'@atlassian/afm-i18n-platform-ai-mate-studio-browse-kit/i18n/nb'
		),
	nl: () =>
		import(
			/* webpackChunkName: "@atlaskit-internal_@atlassian/studio-browse-kit-i18n-nl" */
			'@atlassian/afm-i18n-platform-ai-mate-studio-browse-kit/i18n/nl'
		),
	pl: () =>
		import(
			/* webpackChunkName: "@atlaskit-internal_@atlassian/studio-browse-kit-i18n-pl" */
			'@atlassian/afm-i18n-platform-ai-mate-studio-browse-kit/i18n/pl'
		),
	'pt-BR': () =>
		import(
			/* webpackChunkName: "@atlaskit-internal_@atlassian/studio-browse-kit-i18n-pt_BR" */
			'@atlassian/afm-i18n-platform-ai-mate-studio-browse-kit/i18n/pt_BR'
		),
	ru: () =>
		import(
			/* webpackChunkName: "@atlaskit-internal_@atlassian/studio-browse-kit-i18n-ru" */
			'@atlassian/afm-i18n-platform-ai-mate-studio-browse-kit/i18n/ru'
		),
	sl: () =>
		import(
			/* webpackChunkName: "@atlaskit-internal_@atlassian/studio-browse-kit-i18n-sl" */
			'@atlassian/afm-i18n-platform-ai-mate-studio-browse-kit/i18n/sl'
		),
	'sr-RS': () =>
		import(
			/* webpackChunkName: "@atlaskit-internal_@atlassian/studio-browse-kit-i18n-sr_RS" */
			'@atlassian/afm-i18n-platform-ai-mate-studio-browse-kit/i18n/sr_RS'
		),
	'sr-YR': () =>
		import(
			/* webpackChunkName: "@atlaskit-internal_@atlassian/studio-browse-kit-i18n-sr_YR" */
			'@atlassian/afm-i18n-platform-ai-mate-studio-browse-kit/i18n/sr_YR'
		),
	sv: () =>
		import(
			/* webpackChunkName: "@atlaskit-internal_@atlassian/studio-browse-kit-i18n-sv" */
			'@atlassian/afm-i18n-platform-ai-mate-studio-browse-kit/i18n/sv'
		),
	th: () =>
		import(
			/* webpackChunkName: "@atlaskit-internal_@atlassian/studio-browse-kit-i18n-th" */
			'@atlassian/afm-i18n-platform-ai-mate-studio-browse-kit/i18n/th'
		),
	tr: () =>
		import(
			/* webpackChunkName: "@atlaskit-internal_@atlassian/studio-browse-kit-i18n-tr" */
			'@atlassian/afm-i18n-platform-ai-mate-studio-browse-kit/i18n/tr'
		),
	uk: () =>
		import(
			/* webpackChunkName: "@atlaskit-internal_@atlassian/studio-browse-kit-i18n-uk" */
			'@atlassian/afm-i18n-platform-ai-mate-studio-browse-kit/i18n/uk'
		),
	vi: () =>
		import(
			/* webpackChunkName: "@atlaskit-internal_@atlassian/studio-browse-kit-i18n-vi" */
			'@atlassian/afm-i18n-platform-ai-mate-studio-browse-kit/i18n/vi'
		),
	zh: () =>
		import(
			/* webpackChunkName: "@atlaskit-internal_@atlassian/studio-browse-kit-i18n-zh" */
			'@atlassian/afm-i18n-platform-ai-mate-studio-browse-kit/i18n/zh'
		),
	'zh-TW': () =>
		import(
			/* webpackChunkName: "@atlaskit-internal_@atlassian/studio-browse-kit-i18n-zh_TW" */
			'@atlassian/afm-i18n-platform-ai-mate-studio-browse-kit/i18n/zh_TW'
		),
};

export const fetchMessagesForLocale = async (locale: string): Promise<I18NMessages> => {
	const language = locale.split(/[-_]/)[0];
	const loader = asyncLanguages[locale.replace(/_/g, '-')] ?? asyncLanguages[language];

	try {
		const messages = await loader?.();
		return messages?.default ?? defaultMessages;
	} catch {
		return defaultMessages;
	}
};
